import React, { createContext, useState } from 'react'

export const CommentsContext = createContext({})

function CommentsProvider({ itemId, userData, initialComments, children }) {
  const [state, setState] = useState({
    itemId,
    userData,
    comments: initialComments,
  })

  function addComment(comment) {
    setState((prevState) => ({
      ...prevState,
      comments: [comment, ...prevState.comments],
    }))
  }

  function removeComment(commentId) {
    setState((prevState) => ({
      ...prevState,
      comments: prevState.comments.filter(
        (comment) => comment.id !== `${commentId}`
      ),
    }))
  }

  function editComment(commentId, content) {
    setState((prevState) => ({
      ...prevState,
      comments: prevState.comments.map((comment) => {
        if (comment.id === `${commentId}`) {
          const newComment = {
            ...comment,
            attributes: {
              ...comment.attributes,
              content,
            },
          }
          return newComment
        } else {
          return comment
        }
      }),
    }))
  }

  function addUserData(userData) {
    setState((prevState) => ({
      ...prevState,
      userData,
    }))
  }

  return (
    <CommentsContext.Provider
      value={{
        ...state,
        addComment,
        removeComment,
        editComment,
        addUserData,
      }}
    >
      {children}
    </CommentsContext.Provider>
  )
}

export { CommentsProvider }
